import {
    buildFromWebsocketErrorCode,
    newportInstructions,
} from 'communication/streaming/StreamingErrorText';

export interface EmbeddedLoginErrorText {
    title: string;
    instructions: string;
}

export const embeddedLoginErrors = (reloadPossible: boolean) => ({
    login401: {
        title: 'Authentication failure.',
        instructions:
            newportInstructions(reloadPossible).pleaseRefreshBySelecting,
    },
    login500: {
        title: 'Unexpected error during authentication.',
        instructions:
            newportInstructions(reloadPossible).pleaseCloseAndRelaunch,
    },
    invalidKey: {
        title: 'Invalid credentials.',
        instructions:
            newportInstructions(reloadPossible).pleaseCloseAndRelaunch,
    },
});

export function buildEmbeddedLoginErrorTextFromWebsocketErrorCode(
    errorCode?: number,
    reloadPossible = false
): EmbeddedLoginErrorText {
    const streamingErrorText = buildFromWebsocketErrorCode(
        errorCode,
        reloadPossible
    );
    return {
        title: streamingErrorText.title,
        instructions: streamingErrorText.newportInstructions,
    };
}

export function buildEmbeddedAppLoginErrorTextFromLoginStatus(
    status?: number,
    reloadPossible = false
) {
    if (status === 401) {
        return embeddedLoginErrors(reloadPossible).login401;
    } else {
        return embeddedLoginErrors(reloadPossible).login500;
    }
}
